import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { CHECKOUT_URL } from "../../data/academyData";

const links = [
  { label: "21 Secrets", href: "#resources" },
  { label: "Coach", href: "#coach" },
  { label: "Guarantee", href: "#guarantee" },
  { label: "Pricing", href: "#pricing" },
  { label: "FAQ", href: "#faq" },
];

export const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navigation-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-black/75 backdrop-blur-xl border-b border-white/10 py-3" : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between">
        <a href="#top" className="font-heading text-xl sm:text-2xl font-bold text-white tracking-wide" data-testid="brand-logo">
          AX <span className="text-rose-500">ACADEMY</span>
        </a>
        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm text-zinc-300 hover:text-rose-400 transition-colors"
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
            >
              {l.label}
            </a>
          ))}
        </nav>
        <a
          href={CHECKOUT_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="hidden sm:inline-flex items-center rounded-full bg-rose-600 hover:bg-rose-500 text-white text-sm font-semibold px-5 py-2.5 transition-all hover:scale-105 shadow-[0_0_20px_rgba(229,9,20,0.4)]"
          data-testid="nav-cta-button"
        >
          Claim Founding Membership
        </a>
        <button className="lg:hidden text-white" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle" aria-label="Toggle menu">
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden mt-4 px-4 flex flex-col gap-4 bg-black/95 py-6" data-testid="mobile-menu">
          {links.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="text-zinc-200 text-base">
              {l.label}
            </a>
          ))}
          <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="rounded-full bg-rose-600 text-white text-center py-3 font-semibold">
            Claim Founding Membership
          </a>
        </div>
      )}
    </header>
  );
};
